import Vue          from 'vue'
import { router }   from '../../router'
import JWTDecode    from 'jwt-decode'

export default {
    state: {
        isConnected : false,
        token       : null,
        error       : null,

        user: {
            id          : null,
            email       : null,
            first_name  : null,
            last_name   : null,
            avatar      : null,
            level       : null,
        }
    },

    getters: {

    },

    actions: {
        loadUserState(context) {

            if(!context.state.isConnected) {

                if(localStorage.token) {

                    let decodedToken = JWTDecode(localStorage.token);

                    if(decodedToken.exp > Math.ceil(Date.now() / 1000)) {
                        context.commit('loginFromLocalStorage', { token: localStorage.token })
                    } else {
                        context.commit('logout')
                    }
                }
            }
        },

        login(context, params) {
            Vue.axios.post('/api/login', {
                email: params.email,
                password: params.password

            }).then(response => {
                const token = response.data.token
                const user  = JWTDecode(token).user;

                context.commit('loginSuccess', { user, token })

            }).catch((error) => {
                context.commit('loginError', { error: 'Email ou mot de passe incorrect' })
            })
        },

        clearLoginError(context) {
            context.commit('loginError', { error: null })
        },

        logout(context) {
            Vue.axios.get('/api/logout')
            context.commit('logout')
            router.push('/auth/login')
        }
    },

    mutations: {
        loginFromLocalStorage(state, event) {
            let token = JWTDecode(event.token)

            if(token) {
                state.isConnected       = true
                state.token             = localStorage.token
                state.user.id           = token.user.id
                state.user.email        = token.user.email
                state.user.first_name   = token.user.first_name
                state.user.last_name    = token.user.last_name
                state.user.avatar       = token.user.avatar
                state.user.level        = token.user.level

                Vue.axios.defaults.baseURL = process.env.baseURL;
                Vue.axios.defaults.headers.common.Authorization = `Bearer ${localStorage.token}`;
            }
        },

        loginSuccess(state, event) {
            let decodedToken = JWTDecode(event.token)

            state.token             = event.token
            state.isConnected       = true
            state.user.id           = decodedToken.user.id
            state.user.email        = decodedToken.user.email
            state.user.first_name   = decodedToken.user.first_name
            state.user.last_name    = decodedToken.user.last_name
            state.user.avatar       = decodedToken.user.avatar
            state.user.level       = decodedToken.user.level

            localStorage.token  = state.token
            localStorage.userId  = state.user.id

            Vue.axios.defaults.baseURL = process.env.baseURL;
            Vue.axios.defaults.headers.common.Authorization = `Bearer ${event.token}`
        },

        loginError(state, event) {
            state.error = event.error;
        },

        logout(state) {
            state.token             = null
            state.isConnected       = false
            state.user.id           = null
            state.user.email        = null
            state.user.first_name   = null
            state.user.last_name    = null
            state.user.avatar       = null
            state.user.level        = null

            localStorage.clear();
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js